/** Etiqueta IA guardada en el contacto. El listado solo la muestra; el cron la recalcula. */

export const USUARIOS_ETIQUETA_IA = [1, 568, 334]

const BASE = [
  { id: 'primer_contacto', text: 'PRIMER CONTACTO', match: 'PRIMER CONTACTO', color: '#00BCD4' },
  { id: 'spam', text: 'SPAM', match: 'SPAM', color: '#000000' },
  { id: 'cliente_no_contesta', text: 'CLIENTE NO CONTESTA', match: 'CLIENTE NO CONTESTA', color: '#607D8B' },
  { id: 'cliente_potencial', text: 'CLIENTE POTENCIAL', match: 'CLIENTE POTENCIAL', color: '#7E57C2' },
  { id: 'no_interesado', text: 'NO INTERESADO', match: 'NO INTERESADO', color: '#546E7A' },
  { id: 'examen_enviado', text: 'EXAMEN ENVIADO', match: 'EXAMEN ENVIADO', color: '#FBC02D' },
  { id: 'examen_realizado', text: 'EXAMEN REALIZADO', match: 'EXAMEN REALIZADO', color: '#F9A825' },
  { id: 'cita_agendada', text: 'CITA AGENDADA', match: 'CITA AGENDADA', color: '#8E24AA' },
  { id: 'pendiente_pago', text: 'PENDIENTE DE PAGO', match: 'PENDIENTE DE PAGO', color: '#E53935' },
  { id: 'pago_parcial', text: 'PAGO PARCIAL', match: 'PAGO PARCIAL', color: '#C0A000' },
]

const RE_NO = /no me interesa|no gracias|no quiero|ya no quiero|no estoy interes|no por el momento|no lo quiero/i
const RE_EXAMEN = /fastenglish\.com\.mx\/examen-interno|fastenglish\.com\.mx\/english-level-test|inbi\.mx\/examen-interno|inbi\.mx\/examen-ubicacion|inbi\.mx\/examen-teens/i
const RE_CITA = /cita agend|tu cita|te esperamos|confirmamos tu cita|cita confirm|agendamos tu cita/i
const RE_PAGO = /clabe|transferencia|oxxo|deposito|depósito|cuenta bancaria|datos de pago|datos para pagar|numero de cuenta|número de cuenta/i
const RE_COMPROBANTE = /comprobante|spei|referencia de pago|pago realizado|folio de operaci/i
const RE_SPAM = /xxx|porn|desnudo|nudes|onlyfans|pack de fotos|contenido para adultos/i

export function puedeVerEtiquetaIa (iderp) {
  return USUARIOS_ETIQUETA_IA.indexOf(Number(iderp)) !== -1
}

function normalizar (valor) {
  return String(valor || '')
    .toUpperCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
}

function colorDe (etiquetas, match, fallback) {
  const buscado = normalizar(match)
  const lista = Array.isArray(etiquetas) ? etiquetas : []
  for (let i = 0; i < lista.length; i++) {
    const nombre = normalizar(lista[i].text || lista[i].etiqueta)
    if (!nombre) continue
    if (nombre === buscado || nombre.indexOf(buscado) !== -1) {
      return lista[i].color || fallback
    }
  }
  return fallback
}

export function catalogoEtiquetaIa (etiquetas, conteo) {
  const counts = conteo || {}
  return BASE.map(function (item) {
    return {
      id: item.id,
      text: item.text,
      color: colorDe(etiquetas, item.match, item.color),
      count: counts[item.id] || 0,
    }
  })
}

function esCliente (mensaje) {
  return Number(mensaje && mensaje.mio) === 0
}

function esImagen (mensaje) {
  return Number(mensaje && mensaje.type) === 2
}

function esDocumento (mensaje) {
  return Number(mensaje && mensaje.type) === 4
}

function esTexto (mensaje) {
  const type = mensaje && mensaje.type
  if (type == null || type === '') return true
  return Number(type) === 1
}

/** Señales a partir de los mensajes del chat (o del último, si la lista no trae historial). */
export function senalesDesdeMensajes (mensajes) {
  const lista = Array.isArray(mensajes) ? mensajes : []
  const out = {
    senal_no: 0,
    senal_examen: 0,
    senal_doc_cliente: 0,
    senal_imagen: 0,
    senal_cita_texto: 0,
    senal_pago: 0,
    senal_comprobante: 0,
    senal_spam: 0,
    senal_media_cliente: 0,
    senal_no_contesta: 0,
    totalMensajes: 0,
    mensajesVendedor: 0,
  }

  for (let i = 0; i < lista.length; i++) {
    const mensaje = lista[i]
    const texto = String((mensaje && mensaje.mensaje) || '')
    if (esCliente(mensaje)) out.totalMensajes++
    else out.mensajesVendedor++
    if (esImagen(mensaje)) out.senal_imagen = 1
    if (esCliente(mensaje) && esDocumento(mensaje)) out.senal_doc_cliente = 1
    if (esCliente(mensaje) && (esImagen(mensaje) || esDocumento(mensaje))) out.senal_media_cliente = 1
    if (esCliente(mensaje) && RE_NO.test(texto)) out.senal_no = 1
    if (!esCliente(mensaje) && esTexto(mensaje) && RE_EXAMEN.test(texto)) out.senal_examen = 1
    if (RE_CITA.test(texto)) out.senal_cita_texto = 1
    if (RE_PAGO.test(texto)) out.senal_pago = 1
    if (esCliente(mensaje) && (esImagen(mensaje) || esDocumento(mensaje)) && RE_COMPROBANTE.test(texto)) {
      out.senal_comprobante = 1
    }
    if (esCliente(mensaje) && esImagen(mensaje) && RE_SPAM.test(texto)) out.senal_spam = 1
  }

  if (ultimosSonDeVendedora(lista, 5)) out.senal_no_contesta = 1

  return out
}

function ultimosSonDeVendedora (lista, cantidad) {
  if (!Array.isArray(lista) || lista.length < cantidad) return false
  const ordenados = lista.slice().sort(function (a, b) {
    const fa = fechaMensaje(a)
    const fb = fechaMensaje(b)
    if (fa !== fb) return fa - fb
    return (Number(a && a.idmensajes) || 0) - (Number(b && b.idmensajes) || 0)
  })
  const inicio = ordenados.length - cantidad
  for (let i = inicio; i < ordenados.length; i++) {
    if (esCliente(ordenados[i])) return false
  }
  return true
}

function fechaMensaje (mensaje) {
  const valor = mensaje && mensaje.fecha_creacion
  if (!valor) return 0
  const tiempo = new Date(valor).getTime()
  return isNaN(tiempo) ? 0 : tiempo
}

export function clasificarEtiquetaIa (chat, etiquetas) {
  if (!chat || !chat.etiqueta_ia) return null
  const catalogo = catalogoEtiquetaIa(etiquetas)
  for (let i = 0; i < catalogo.length; i++) {
    if (catalogo[i].id === chat.etiqueta_ia) return catalogo[i]
  }
  return null
}
